import { Box } from '@mui/material';

import useScript from '../utils/useScript-util.js';

export default function GoogleSSOSignIn({
  onGoogleSignIn = () => {
    // do nothing.
  }, lang
}) {
  /* global google */
  /* eslint-disable-next-line */
  const clientId = process.env.REACT_APP_GOOGLE_SSO_CLIENT_ID; /* eslint-disable-line */
  useScript(`https://accounts.google.com/gsi/client?hl=${lang}`, () => {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: onGoogleSignIn,
    });
    google.accounts.id.renderButton(
      document.getElementById("googleSSODiv"),
      { theme: 'outline', size: 'large', shape: 'rectangular', text: 'signin_with', width: 400, locale: lang }, // customization attributes
    );
  });

  return <Box id="googleSSODiv"></Box>;
}